import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLeadConversionReport } from "../../services/reports2.services";

export const fetchEnquiryToCustomerReport = createAsyncThunk(
  "enquiryToCustomer/fetchReport",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getLeadConversionReport("enquiry_to_customer");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const enquiryToCustomerSlice = createSlice({
  name: "enquiryToCustomer",
  initialState: {
    data: [],
    list: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnquiryToCustomerReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEnquiryToCustomerReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.list = action.payload.list;
      })
      .addCase(fetchEnquiryToCustomerReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default enquiryToCustomerSlice.reducer;
